import { Routes } from '@angular/router';
import { ALLOW_ACCESS_ROUTE_GUARD } from './shared/router/allowAccessRouteGuard';
import { portfoliosResolver } from './portfolio/resolvers/portfolios-resolver';
import { securityTypesResolver } from './portfolio/resolvers/security-types-resolver';
import { investmentsTransactionTypesResolver } from './portfolio/resolvers/investments-transaction-types-resolver';
import { bankingTransactionTypesResolver } from './banking/sco-reporting/resolvers/banking-transaction-types-resolver';
import { bankingAllAgenciesResolver } from './banking/sco-reporting/resolvers/banking-all-agencies-resolver';
import { bankingAllFundsResolver } from './banking/sco-reporting/resolvers/banking-all-funds-resolver';

export const ROUTES: Routes = [
  {
    path: 'warrant-request',
    loadComponent: () =>
      import('./warrant-request/warrant-request.component').then((m) => m.WarrantRequestComponent),
  },
  {
    path: 'login/tatrs-login',
    loadComponent: () =>
      import('./login/tatrs-login/tatrs-login.component').then(
        (m) => m.TatrsLoginComponent
      ),
  },
  {
    path: 'account',
    children: [
      {
        path: 'change-email-preferences',
        loadComponent: () =>
          import(
            './account/change-email-preferences/change-email-preferences.component'
          ).then((m) => m.ChangeEmailPreferencesComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./account/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import(
            './account/reset-password/reset-password.component'
          ).then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'forgot-username',
        loadComponent: () =>
          import('./account/forgot-username/forgot-username.component').then(
            (m) => m.ForgotUsernameComponent
          ),
      },
      {
        path: 'change-password/:expired',
        loadComponent: () =>
          import('./account/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent
          ),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./account/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent
          ),
      },
      {
        path: 'change-contact-information',
        loadComponent: () =>
          import(
            './account/change-contact-information/change-contact-information.component'
          ).then((m) => m.ChangeContactInformationComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
    ],
  },
  {
    path: 'banking',
    children: [
      {
        path: 'change-email-preferences',
        loadComponent: () =>
          import(
            './banking/change-email-preferences/change-email-preferences.component'
          ).then((m) => m.ChangeEmailPreferencesComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'counties',
        children: [
          {
            path: 'county-receipts-entry',
            loadComponent: () =>
              import(
                './banking/counties/county-receipts-entry-container/county-receipts-entry.component'
              ).then((m) => m.CountyReceiptsEntryComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'county-receipts-entry/:countyReceiptsId/:countyId',
            loadComponent: () =>
              import(
                './banking/counties/county-receipts-entry-container/county-receipts-entry.component'
              ).then((m) => m.CountyReceiptsEntryComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'county-receipts-entry-pending',
            loadComponent: () =>
              import(
                './banking/counties/county-receipts-pending/county-receipts-pending.component'
              ).then((m) => m.CountyReceiptsPendingComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'county-receipts-transmittal-search',
            loadComponent: () =>
              import(
                './banking/counties/county-receipts-transmittal-search/county-receipts-transmittal-search.component'
              ).then((m) => m.CountyReceiptsTransmittalSearchComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
      {
        path: 'sco-reporting',
        children: [
          {
            path: 'fund-ledger-report',
            loadComponent: () =>
              import(
                './banking/sco-reporting/fund-ledger-report/fund-ledger-report.component'
              ).then((m) => m.FundLedgerReportComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
            resolve: { transactionTypes: bankingTransactionTypesResolver, allAgencies: bankingAllAgenciesResolver, allFunds: bankingAllFundsResolver },
          },
          {
            path: 'return-nocs-report',
            loadComponent: () =>
              import(
                './banking/sco-reporting/return-nocs-report/return-nocs-report.component'
              ).then((m) => m.ReturnNocsReportComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
      {
        path: 'transaction-headers',
        loadComponent: () =>
          import(
            './banking/transaction-headers/transaction-headers.component'
          ).then((m) => m.TransactionHeadersComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'interest-proration',
        children: [
          {
            path: 'monthly-statement-list',
            loadComponent: () =>
              import(
                './banking/interest-proration/monthly-statement-list/monthly-statement-list.component'
              ).then((m) => m.MonthlyStatementListComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'idle-interest-received',
            loadComponent: () =>
              import(
                './banking/interest-proration/idle-interest-received/idle-interest-received.component'
              ).then((m) => m.IdleInterestReceivedComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
            resolve: { agencies: bankingAllAgenciesResolver },
          },
        ],
      },
      {
        path: 'return-checks',
        children: [
          {
            path: 'download-return-checks-images',
            loadComponent: () =>
              import(
                './banking/return-checks/download-return-checks-images/download-return-checks-images.component'
              ).then((m) => m.DownloadReturnChecksImagesComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
    ],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'dbf',
    children: [
      {
        path: 'board-members-authorized-users',
        loadComponent: () =>
          import(
            './pool-accounting/dbf/board-members-authorized-users/board-members-authorized-users.component'
          ).then((m) => m.BoardMembersAuthorizedUsersComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'change-email-preferences',
        loadComponent: () =>
          import(
            './pool-accounting/dbf/change-email-preferences/change-email-preferences.component'
          ).then((m) => m.ChangeEmailPreferencesComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'confirmation-number-search',
        loadComponent: () =>
          import(
            './pool-accounting/dbf/confirmation-number-search/confirmation-number-search.component'
          ).then((m) => m.ConfirmationNumberSearchComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'fund-account-nickname',
        loadComponent: () =>
          import(
            './pool-accounting/dbf/fund-account-nickname/fund-account-nickname.component'
          ).then((m) => m.FundAccountNicknameComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./pool-accounting/dbf/home/home.component'
          ).then((m) => m.HomeComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'monthly-statement',
        children: [
          {
            path: 'view-monthly-statement',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/monthly-statement/view-monthly-statement/view-monthly-statement.component'
              ).then((m) => m.ViewMonthlyStatementComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'view-monthly-statement/:a',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/monthly-statement/view-monthly-statement/view-monthly-statement.component'
              ).then((m) => m.ViewMonthlyStatementComponent),
            //canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'print-monthly-statement',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/monthly-statement/print-monthly-statement/print-monthly-statement.component'
              ).then((m) => m.PrintMonthlyStatementComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
      {
        path: 'administrative-fees',
        loadComponent: () =>
          import(
            './pool-accounting/dbf/administrative-fees/administrative-fees.component'
          ).then((m) => m.AdministrativeFeesComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'transaction',
        children: [
          {
            path: 'void-pending-transactions',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/void-pending-transactions/void-pending-transactions.component'
              ).then((m) => m.VoidPendingTransactionsComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'pending-transactions',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/pending-transactions/pending-transactions.component'
              ).then((m) => m.PendingTransactionsComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-batches',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-batches/transaction-batches.component'
              ).then((m) => m.TransactionBatchesComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'default-luma-settings',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/default-luma-settings/default-luma-settings.component'
              ).then((m) => m.DefaultLumaSettingsComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-search',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-search/transaction-search.component'
              ).then((m) => m.TransactionSearchComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-request',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-request/transaction-request.component'
              ).then((m) => m.TransactionRequestComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
      {
        path: 'transaction/transaction-request',
        children: [
          {
            path: 'luma',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-request/luma/luma.component'
              ).then((m) => m.LumaComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'verification',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-request/verification/verification.component'
              ).then((m) => m.VerificationComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'confirmation',
            loadComponent: () =>
              import(
                './pool-accounting/dbf/transaction/transaction-request/confirmation/confirmation.component'
              ).then((m) => m.ConfirmationComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
    ],
  },
  {
    path: 'workers-comp/net-holdings',
    children: [
      {
        path: 'holdings-per-security-number',
        loadComponent: () =>
          import(
            './workers-comp/net-holdings/holdings-per-security-number/holdings-per-security-number.component'
          ).then((m) => m.HoldingsPerSecurityNumberComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'holdings-per-security-type',
        loadComponent: () =>
          import(
            './workers-comp/net-holdings/holdings-per-security-type/holdings-per-security-type.component'
          ).then((m) => m.HoldingsPerSecurityTypeComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
    ]
  },
  {
    path: 'workers-comp/transaction',
    children: [
      {
        path: 'transaction-detail',
        loadComponent: () =>
          import(
            './workers-comp/transaction/transaction-detail/transaction-detail.component'
          ).then((m) => m.TransactionDetailComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
    ]
  },
  {
    path: 'debt-management/continuing-disclosure',
    children: [
      {
        path: 'submittal',
        loadComponent: () =>
          import(
            './debt-management/continuing-disclosure/submittal/submittal.component'
          ).then((m) => m.SubmittalComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'submittal-report',
        loadComponent: () =>
          import(
            './debt-management/continuing-disclosure/submittal-report/submittal-report.component'
          ).then((m) => m.SubmittalReportComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
    ],
  },
  {
    path: 'debt-management/state-supported-debt',
    children: [
      {
        path: 'outstanding-debt-by-entity',
        loadComponent: () =>
          import(
            './debt-management/state-supported-debt/outstanding-debt-by-entity/outstanding-debt-by-entity.component'
          ).then((m) => m.OutstandingDebtByEntityComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'outstanding-debt-by-issuer',
        loadComponent: () =>
          import(
            './debt-management/state-supported-debt/outstanding-debt-by-issuer/outstanding-debt-by-issuer.component'
          ).then((m) => m.OutstandingDebtByIssuerComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'outstanding-debt-by-year',
        loadComponent: () =>
          import(
            './debt-management/state-supported-debt/outstanding-debt-by-year/outstanding-debt-by-year.component'
          ).then((m) => m.OutstandingDebtByYearComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'verify-payment/validate',
        loadComponent: () =>
          import(
            './debt-management/state-supported-debt/verify-payment/verify-payment.component'
          ).then((m) => m.VerifyPaymentComponent),
      },
    ],
  },
  {
    path: 'lgip',
    children: [
      {
        path: 'board-members-authorized-users',
        loadComponent: () =>
          import(
            './pool-accounting/lgip/board-members-authorized-users/board-members-authorized-users.component'
          ).then((m) => m.BoardMembersAuthorizedUsersComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'change-email-preferences',
        loadComponent: () =>
          import(
            './pool-accounting/lgip/change-email-preferences/change-email-preferences.component'
          ).then((m) => m.ChangeEmailPreferencesComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'confirmation-number-search',
        loadComponent: () =>
          import(
            './pool-accounting/lgip/confirmation-number-search/confirmation-number-search.component'
          ).then((m) => m.ConfirmationNumberSearchComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'fund-account-nickname',
        loadComponent: () =>
          import(
            './pool-accounting/lgip/fund-account-nickname/fund-account-nickname.component'
          ).then((m) => m.FundAccountNicknameComponent),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./pool-accounting/lgip/home/home.component').then(
            (m) => m.HomeComponent
          ),
        canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
      },
      {
        path: 'monthly-statement',
        children: [
          {
            path: 'view-monthly-statement',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/monthly-statement/view-monthly-statement/view-monthly-statement.component'
              ).then((m) => m.ViewMonthlyStatementComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'view-monthly-statement/:a',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/monthly-statement/view-monthly-statement/view-monthly-statement.component'
              ).then((m) => m.ViewMonthlyStatementComponent),
            //canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'print-monthly-statement',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/monthly-statement/print-monthly-statement/print-monthly-statement.component'
              ).then((m) => m.PrintMonthlyStatementComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
      {
        path: 'transaction',
        children: [
          {
            path: 'transaction-request',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/transaction-request/transaction-request.component'
              ).then((m) => m.TransactionRequestComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-request-verification',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/transaction-request/transaction-request-verification/transaction-request-verification.component'
              ).then((m) => m.TransactionRequestVerificationComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-request-confirmation',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/transaction-request/transaction-request-confirmation/transaction-request-confirmation.component'
              ).then((m) => m.TransactionRequestConfirmationComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'transaction-search',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/transaction-search/transaction-search.component'
              ).then((m) => m.TransactionSearchComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
          {
            path: 'void-pending-transactions',
            loadComponent: () =>
              import(
                './pool-accounting/lgip/transaction/void-pending-transactions/void-pending-transactions.component'
              ).then((m) => m.VoidPendingTransactionsComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
          },
        ],
      },
    ],
  },
  {
    path: 'portfolio',
    children: [
      {
        path: 'reports',
        children: [
          {
            path: 'investment-inventory',
            loadComponent: () =>
              import(
                './portfolio/reports/investment-inventory/investment-inventory.component'
              ).then((m) => m.InvestmentInventoryComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
            resolve: { portfolios: portfoliosResolver, securityTypes: securityTypesResolver },
          },
          {
            path: 'transaction-detail',
            loadComponent: () =>
              import(
                './portfolio/reports/transaction-detail/transaction-detail.component'
              ).then((m) => m.TransactionDetailComponent),
            canActivate: [ALLOW_ACCESS_ROUTE_GUARD],
            resolve: { portfolios: portfoliosResolver, securityTypes: securityTypesResolver, transactionTypes: investmentsTransactionTypesResolver },
          },
        ],
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./login/login.component').then((m) => m.LoginComponent),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
  }
];
